import React, { useEffect } from 'react'
import Toggle from './ThemeToggle'
import { useState } from "react";
import { Link, useMatch, useResolvedPath, useLocation } from "react-router-dom"
import background from "../assets/images/background_0.png";
import logo from "../assets/images/washxpress_logo.png";
import logo2 from "../assets/images/v1/banner-lu-write.svg";
import logo3 from "../assets/images/icon_app.png";
import SearchComponent from './SearchComponent'
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive';
import Typography from '@mui/material/Typography';
import { styled, alpha } from '@mui/material/styles';
import { TreeItem, useTreeItem } from '@mui/x-tree-view/TreeItem';
import clsx from 'clsx';
import { TreeView } from '@mui/x-tree-view/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IoIosAddCircle } from 'react-icons/io';
import { AiFillMinusCircle } from 'react-icons/ai';
import { FaTreeCity } from "react-icons/fa6";

import { FaMapLocation } from "react-icons/fa6";
import { GiMoneyStack } from "react-icons/gi";
import { GoTasklist } from "react-icons/go";
import { IoBuildOutline } from "react-icons/io5";
import { SiNamecheap } from "react-icons/si";
import { MdPersonOff } from "react-icons/md";
import { GiAbstract063 } from "react-icons/gi";
import { AiOutlineShop } from "react-icons/ai";
import { LuGripHorizontal } from "react-icons/lu";
import { MdOutlineSettingsAccessibility } from "react-icons/md";
import { TfiHeadphoneAlt } from "react-icons/tfi";

import { TbTruckDelivery, TbListDetails } from 'react-icons/tb'
import { MdStoreMallDirectory, MdOutlineDataExploration, MdOutlinePayments } from 'react-icons/md'
import { FaTasks, FaUserCog, FaCoins, FaWallet, FaMapMarkerAlt } from 'react-icons/fa'
import { BsCashCoin, BsShopWindow } from 'react-icons/bs'
import { GrVend, GrMap, GrHostMaintenance, GrVmMaintenance } from 'react-icons/gr'
import { RiCustomerService2Fill } from 'react-icons/ri'
import { AiOutlineLogin, AiTwotoneShop, AiOutlineWallet, AiOutlineLogout, AiOutlineTool } from 'react-icons/ai'
import { TbReport } from "react-icons/tb";
import { GiCash, GiCoins, GiTwoCoins, GiTakeMyMoney, GiWashingMachine, GiVendingMachine, GiHamburgerMenu, GiSpiralBottle } from 'react-icons/gi'
import { RiUserLocationFill } from 'react-icons/ri'
import { CiCoinInsert } from 'react-icons/ci'
import { FaFileInvoiceDollar, FaBoxes, FaDumpsterFire, FaFireAlt } from 'react-icons/fa'
import { FaClipboardList, FaWarehouse, FaRegCalendarAlt } from 'react-icons/fa'
import { ImMeter } from 'react-icons/im'
import { TbReportAnalytics } from 'react-icons/tb'
import { BiImport } from 'react-icons/bi'
import { RiLogoutCircleFill } from "react-icons/ri";
import { AiFillSetting, AiOutlineReconciliation } from 'react-icons/ai'
import { HiOutlineUsers } from 'react-icons/hi'
import { ImUserTie } from 'react-icons/im'
import { HiFire } from 'react-icons/hi'
import { MdDashboard, MdCleaningServices, MdLocalLaundryService, MdProductionQuantityLimits, MdIron } from 'react-icons/md'
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import { treeItemClasses } from '@mui/lab/TreeItem';
import Box from '@mui/material/Box';
import { LiaFileContractSolid } from "react-icons/lia";
import { FaPaste } from "react-icons/fa";
import { RiListSettingsLine } from "react-icons/ri";
import * as MaterialDesign from "react-icons/md";
import * as AntDesign from "react-icons/ai";
import * as  FontAwesomeDesign from "react-icons/fa";
import * as  GameDesign from "react-icons/gi";
import * as TablerDesign from "react-icons/tb";
import * as BootstrapDesign from "react-icons/bs";
import * as GrommetDesign from "react-icons/gr";
import * as IoniconsDesign from "react-icons/io";
import * as PhosphorDesign from "react-icons/pi";
import * as RemixDesign from "react-icons/ri";

import * as Grommet from "react-icons/gr";
import * as Bootstrap from "react-icons/bs";
import { GoPasskeyFill } from "react-icons/go";
import IconButton from '@mui/material/IconButton';
import ChangePasswordByUserForm from '../pages/Master/User/ChangePasswordByUserForm'
import { logout } from '../pages/Auth/hook/useLogin'
import LoadingPage from '../components/Loading'




import {
    pageMenuHandler,
    authTokenHandler,
    sessionHandler
} from "../util/local-storage";
import { MdOutlineManageAccounts, MdOutlineFilterList } from "react-icons/md";

const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({


    color: theme.palette.text.secondary,
    [`& .${treeItemClasses.content}`]: {
        color: theme.palette.text.secondary,
        //borderTopRightRadius: theme.spacing(2),
        //borderBottomRightRadius: theme.spacing(2),
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        flexDirection: "row-reverse",
        paddingRight: theme.spacing(0),

        //paddingRight: '2px',
        fontWeight: theme.typography.fontWeightMedium,
        '&.Mui-expanded': {
            fontWeight: theme.typography.fontWeightRegular,
        },
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
            color: 'var(--tree-view-color)',
        },
        [`& .${treeItemClasses.label}`]: {
            fontWeight: 'inherit',
            color: 'inherit',
        },
    },
    // ระยะย่อหน้าของเมนูย่อย - ดู Sidebar.js ที่เป็นบั๊กเดียวกัน (โค้ดสองไฟล์นี้ลอกกันมา)
    // marginLeft: 0 ปิด indent ที่ MUI ทำให้ และตัวชดเชยถูก comment ทิ้ง เมนูย่อยจึงอยู่
    // ตำแหน่งแนวนอนเดียวกับเมนูหลัก แยกด้วยตาไม่ออก
    //
    // ที่นี่ไม่ต้องเช็คสถานะหุบ/กางเหมือน Sidebar เพราะเมนูบนมือถือเป็น drawer
    // ที่แสดงชื่อเมนูเต็มอยู่แล้ว ไม่มีโหมดเหลือแต่ไอคอน
    [`& .${treeItemClasses.group}`]: {
        marginLeft: theme.spacing(2.5),
        paddingLeft: theme.spacing(1.25),
        borderLeft: '1px solid rgba(255, 255, 255, 0.30)',
    },
}));


function StyledTreeItem(props) {


    const {
        bgColor,
        color,
        labelIcon: LabelIcon,
        labelInfo,
        labelText,
        ttitle,
        // 0 = เมนูหลัก, 1 = เมนูย่อย  ต้องดึงออกก่อน spread ไม่ให้หลุดไปเป็น DOM attribute
        depth = 0,
        ...other
    } = props;

    const isSub = depth > 0;

    return (


        < StyledTreeItemRoot
            label={

                <Tooltip title={ttitle} placement='right-end' arrow >

                    < Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        pt: isSub ? 0.5 : 1,
                        pb: isSub ? 0.5 : 1,
                        pr: 0,
                        color: "#000",
                    }}>

                        <Link to={props.to} className='flex'>
                            <Box
                                component={LabelIcon}
                                className={`${isSub ? 'text-lg' : 'text-2xl'} text-white`}
                                sx={isSub ? { opacity: 0.8 } : null}
                            />


                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: isSub ? 400 : 500,
                                    flexGrow: 1,
                                    ...(isSub && { fontSize: '0.8rem', opacity: 0.88, pl: 0.5 }),
                                }}
                                className='text-white'
                            >
                                {labelText}
                            </Typography>
                            <Typography variant="caption" color="inherit">
                                {labelInfo}
                            </Typography>

                        </Link>
                    </Box >

                </Tooltip>


            }
            style={{
                '--tree-view-color': color,
                '--tree-view-bg-color': bgColor,
            }}
            {...other}
        />


    );
}


StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
    /** 0 = เมนูหลัก, 1 = เมนูย่อย */
    depth: PropTypes.number,
};

const Navbar = () => {
    const userRole = localStorage.getItem('role');
    const [navbar, setNavbar] = useState(false);
    const [userName, setUserName] = useState("");
    const [isDisplayChangePassword, setIsDisplayChangePassword] = useState(false);
    const [loadingPageFlag, setLoadingPageFlag] = useState(2);

    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
    //var Menus = JSON.parse(pageMenuHandler.get() ?? []) ?? [];
    let Menus = pageMenuHandler.get() !== undefined ? (JSON.parse(pageMenuHandler.get()) ?? []) : [];
    Menus.push({
        title: 'Logout', path: '/login', src: AiOutlineLogin, orderID: 9
        , sub: []
    });


    const handleChangePassword = () => {

        setIsDisplayChangePassword(true);

    }

    const handleClosePopup = (event, reason) => {

        if (reason && reason == "backdropClick" && "escapeKeyDown")
            return;
        setIsDisplayChangePassword(false);

    }

    const editPasswordHandler = (values) => {

        handleClosePopup();
    }
    //const logoutHandler = () => {

    //    setLoadingPageFlag(1);
    //    if (authTokenHandler.get() != null) {

    //        logout().then((result) => {

    //            const { code, status, data, message, description } = result;

    //            if (status === 200 || code === 200) {
    //                sessionHandler.clear();
    //                setLoadingPageFlag(2);
    //                navigate('/login');

    //            } else {
    //                setLoadingPageFlag(2);
    //                sessionHandler.clear();
    //                navigate('/login');
    //            }

    //        }).catch(error => {

    //            setOpenDialog(true);
    //            setLoadingPageFlag(2);
    //            navigate('/login');
    //            console.error(error.message);
    //        });
    //    } else {
    //        navigate('/login');
    //    }

    //}


    const logoutHandler = async () => {
        if (authTokenHandler.get() != null) {
            setLoadingPageFlag(1);

            try {
                const result = await logout();
                const { code, status, data, message, description } = result;

                if (status === 200 || code === 200) {
                    sessionHandler.clear();
                    setLoadingPageFlag(2);
                    navigate('/login');
                } else {
                    sessionHandler.clear();
                    setLoadingPageFlag(2);
                    navigate('/login');
                }

            } catch (error) {
                setOpenDialog(true);
                setLoadingPageFlag(2);
                navigate('/login');
                console.error(error.message);
            }

        } else {
            navigate('/login');
        }
    }

    const menuIcon = (itemIcon) => {
        var icon = FaUserCog;
        let strIcon = itemIcon ?? "";
        try {
            if (strIcon.includes('FaUserCog')) {
                icon = FaUserCog;

            } else if (strIcon.includes('AiFillSetting')) {
                icon = AiFillSetting;
            }
            else if (strIcon.includes('BsShopWindow')) {
                icon = BsShopWindow;
            }
            else if (strIcon.includes('ImUserTie')) {
                icon = ImUserTie;
            }
            else if (strIcon.includes('HiFire')) {
                icon = HiFire;
            }
            else if (strIcon.includes('GiWashingMachine')) {
                icon = GiWashingMachine;
            }
            else if (strIcon.includes('HiOutlineUsers')) {
                icon = HiOutlineUsers;
            }
            else if (strIcon.includes('AiTwotoneShop')) {
                icon = AiTwotoneShop;
            }
            else if (strIcon.includes('MdLocalLaundryService')) {
                icon = MdLocalLaundryService;
            }
            else if (strIcon.includes('FaDumpsterFire')) {
                icon = FaDumpsterFire;
            }
            else if (strIcon.includes('BiImport')) {
                icon = BiImport;
            }
            else if (strIcon.includes('AiOutlineReconciliation')) {
                icon = AiOutlineReconciliation;
            }
            else if (strIcon.includes('GiTakeMyMoney')) {
                icon = GiTakeMyMoney;
            }
            else if (strIcon.includes('GiCash')) {
                icon = GiCash;
            }
            else if (strIcon.includes('MdIron')) {
                icon = MdIron;
            }
            else if (strIcon.includes('FaFileInvoiceDollar')) {
                icon = FaFileInvoiceDollar;
            }
            else if (strIcon.includes('GiVendingMachine')) {
                icon = GiVendingMachine;
            }
            else if (strIcon.includes('MdOutlinePayments')) {
                icon = MdOutlinePayments;
            }
            else if (strIcon.includes('FaWarehouse')) {
                icon = FaWarehouse;
            }
            else if (strIcon.includes('FaClipboardList')) {
                icon = FaClipboardList;
            }
            else if (strIcon.includes('FaBoxes')) {
                icon = FaBoxes;
            }
            else if (strIcon.includes('GiTwoCoins')) {
                icon = GiTwoCoins;
            }
            else if (strIcon.includes('RiUserLocationFill')) {
                icon = RiUserLocationFill;
            }
            else if (strIcon.includes('GiSpiralBottle')) {
                icon = GiSpiralBottle;
            }
            else if (strIcon.includes('ImMeter')) {
                icon = ImMeter;
            }
            else if (strIcon.includes('MdCleaningServices')) {
                icon = MdCleaningServices;
            }
            else if (strIcon.includes('MdOutlinePayments')) {
                icon = MdOutlinePayments;
            }
            else if (strIcon.includes('AiOutlineWallet')) {
                icon = AiOutlineWallet;
            }
            else if (strIcon.includes('FaMapMarkerAlt')) {
                icon = FaMapMarkerAlt;
            }
            else if (strIcon.includes('MdOutlineManageAccounts')) {
                icon = MdOutlineManageAccounts;
            }
            else if (strIcon.includes('BsShopWindow')) {
                icon = BsShopWindow;
            }
            else if (strIcon.includes('TbListDetails')) {
                icon = TbListDetails;
            }
            else if (strIcon.includes('RiListSettingsLine')) {
                icon = RiListSettingsLine;
            }
            else if (strIcon.includes('AiOutlineTool')) {
                icon = AiOutlineTool;
            }
            else if (strIcon.includes('MdOutlineFilterList')) {
                icon = MdOutlineFilterList;
            }
            else if (strIcon.includes('FaMapMarkerAlt')) {
                icon = FaMapMarkerAlt;
            }
            else if (strIcon.includes('FaMapLocation')) {
                icon = FaMapLocation;
            }
            else if (strIcon.includes('GiMoneyStack')) {
                icon = GiMoneyStack;
            }
            else if (strIcon.includes('MdIron')) {
                icon = MdIron;
            }
            else if (strIcon.includes('FaRegCalendarAlt')) {
                icon = FaRegCalendarAlt;
            }
            else if (strIcon.includes('GoTasklist')) {
                icon = GoTasklist;
            }
            else if (strIcon.includes('IoBuildOutline')) {
                icon = IoBuildOutline;
            }
            else if (strIcon.includes('SiNamecheap')) {
                icon = SiNamecheap;
            }
            else if (strIcon.includes('MdPersonOff')) {
                icon = MdPersonOff;
            }
            else if (strIcon.includes('GiAbstract063')) {
                icon = GiAbstract063;
            }
            else if (strIcon.includes('AiOutlineShop')) {
                icon = AiOutlineShop;
            }
            else if (strIcon.includes('LuGripHorizontal')) {
                icon = LuGripHorizontal;
            }
            else if (strIcon.includes('MdOutlineSettingsAccessibility')) {
                icon = MdOutlineSettingsAccessibility;
            }
            else if (strIcon.includes('TfiHeadphoneAlt')) {
                icon = TfiHeadphoneAlt;
            }

            else if (strIcon.includes('MaterialDesign')) {
                let txtIcon = strIcon.replace('MaterialDesign.', "");
                icon = MaterialDesign[txtIcon];
            }
            else if (strIcon.includes('AntDesign')) {
                let txtIcon = strIcon.replace('AntDesign.', "");
                icon = AntDesign[txtIcon];
            }
            else if (strIcon.includes('FontAwesomeDesign')) {
                let txtIcon = strIcon.replace('FontAwesomeDesign.', "");
                icon = FontAwesomeDesign[txtIcon];
            }
            else if (strIcon.includes('GameDesign')) {
                let txtIcon = strIcon.replace('GameDesign.', "");
                icon = GameDesign[txtIcon];
            }
            else if (strIcon.includes('Grommet')) {
                let txtIcon = strIcon.replace('Grommet.', "");
                icon = Grommet[txtIcon];
            }
            else if (strIcon.includes('Bootstrap')) {
                let txtIcon = strIcon.replace('Bootstrap.', "");
                icon = Bootstrap[txtIcon];
            }
            else if (strIcon.includes('TablerDesign')) {
                let txtIcon = strIcon.replace('TablerDesign.', "");
                icon = TablerDesign[txtIcon];
            }
            else if (strIcon.includes('BootstrapDesign')) {
                let txtIcon = strIcon.replace('BootstrapDesign.', "");
                icon = BootstrapDesign[txtIcon];
            }
            else if (strIcon.includes('GrommetDesign')) {
                let txtIcon = strIcon.replace('GrommetDesign.', "");
                icon = GrommetDesign[txtIcon];
            }
            else if (strIcon.includes('IoniconsDesign')) {
                let txtIcon = strIcon.replace('IoniconsDesign.', "");
                icon = IoniconsDesign[txtIcon];
            }
            else if (strIcon.includes('PhosphorDesign')) {
                let txtIcon = strIcon.replace('PhosphorDesign.', "");
                icon = PhosphorDesign[txtIcon];
            }
            else if (strIcon.includes('RemixDesign')) {
                let txtIcon = strIcon.replace('RemixDesign.', "");
                icon = RemixDesign[txtIcon];
            }
            else {
                icon = FaUserCog
            }

        } catch (e) {

            icon = FaUserCog
        }
        return icon;

    }


    useEffect(() => {

        var locationPath = window.location;

        const strUserName = localStorage.getItem("displayName");

        if (strUserName != null && strUserName != undefined && strUserName != "") {

            setUserName(strUserName);
        } else {

            // 
            if (locationPath.pathname === "/laundryyouupdate" || locationPath.pathname ==="/auditqtn") {

            } else {

                handleLogout();

            }


        }




    }, [userName])

    function EnhancedTableHead(props) {
        const { onSelectAllClick, numSelected, rowCount, onRequestSort } =
            props;
        // const createSortHandler = (property) => (event) => {
        //     onRequestSort(event, property);
        // }; 

        if (userRole === "VENDER") {
            return (
                <div className="justify-between px-4 mx-auto  md:items-center md:flex md:px-8">

                    <div>
                        <div className="flex items-center justify-between pt-3 md:pt-5 md:block   ">

                            <Link to='/'>
                                <img src={logo2} className='h-12 mr-3 pb-2 ' alt='medium.ia logo' />
                            </Link>
                            {/* <div className='h-12 '></div> */}
                            <div className="md:hidden">
                                {/* <div >  <SearchComponent style={{ display: flagMobile === 1 ? 'block' : 'none' }} /></div> */}
                                <button
                                    className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"

                                    onClick={() => setNavbar(!navbar)}
                                >
                                    {navbar ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-6 h-6 text-white"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    ) : (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="w-6 h-6 text-white"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M4 6h16M4 12h16M4 18h16"
                                            />
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${navbar ? "block" : "hidden"
                                }`}
                        >
                            <ul className="items-center justify-center space-y-8 md:flex md:space-x-6 md:space-y-0">


                            </ul>




                        </div>
                    </div>

                    <div className="hidden space-x-2 md:inline-block ">
                        <div className="flex items-center space-x-2">


                            <div>

                            </div>



                        </div>
                    </div>


                </div>
            );
        } else {
            return (
                <>
                    <div className="justify-between px-4 mx-auto  md:items-center md:flex md:px-8">
                        <div>
                            <div className="flex items-center justify-between pt-3 md:pt-5 md:block   ">

                                <Link to='/'>
                                    <img src={logo2} className='h-12 mr-3   pb-2' alt='medium.ia logo' />
                                </Link>
                                {/* <div className='h-12 '></div> */}
                                <div className="md:hidden">
                                    {/* <div >  <SearchComponent style={{ display: flagMobile === 1 ? 'block' : 'none' }} /></div> */}
                                    <button
                                        className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"

                                        onClick={() => setNavbar(!navbar)}
                                    >
                                        {navbar ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-6 h-6 text-white"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-6 h-6 text-white"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M4 6h16M4 12h16M4 18h16"
                                                />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div
                                className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${navbar ? "block" : "hidden"
                                    }`}
                            >





                            </div>
                        </div>

                        <div className="hidden space-x-2 md:inline-block ">
                            <div className="flex items-center space-x-2">
                                <SearchComponent style={{ display: !isMobile ? 'block' : 'none' }} />
                                <a href="#">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6 text-gray-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                                        />
                                    </svg>
                                </a>
                                <div>

                                </div>
                                {/*<a href="#">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6 text-gray-400"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                    />
                                </svg>
                            </a>*/}

                                <div>


                                    <IconButton aria-label="change password" title='change password' onClick={(event) => {
                                        handleChangePassword();
                                    }}>
                                        <GoPasskeyFill className=' flex text-gray-400' />
                                    </IconButton>
                                </div>

                                {/*<a href='/login' className='flex text-gray-400'>
                                    <RiLogoutCircleFill className="w-6 h-6 " /><span className='pl-2'> Log Out </span>
                                </a>*/}
                                <IconButton aria-label="change password" title='change password' onClick={(event) => {
                                    logoutHandler();
                                }}>
                                    <RiLogoutCircleFill className=' flex text-gray-400' /><span className='pl-2  text-gray-400  text-base '> Log Out </span>
                                </IconButton>

                                <div>



                                </div>


                                <span>

                                </span>
                            </div>
                        </div>


                    </div>
                    {isDisplayChangePassword && <ChangePasswordByUserForm /* data={stateUserUpdate} */ editPasswordHandler={editPasswordHandler} isDisplay={isDisplayChangePassword} handleClose={handleClosePopup} />}
                </>
            );
        }

    }

    function EnhancedTableHeadMB(props) {
        const { onSelectAllClick, numSelected, rowCount, onRequestSort } =
            props;
        // const createSortHandler = (property) => (event) => {
        //     onRequestSort(event, property);
        // };

        return (
            <div className="justify-between  mx-auto  md:items-center md:flex md:px-8">

                <div>
                    <div className="flex items-center justify-between pt-3 md:pt-5 md:block   ">

                        <Link to='/'>
                            <img src={logo2} className='h-12 mr-3    ' alt='medium.ia logo' />
                        </Link>
                        {/* <div className='h-12 '></div> */}
                        <div className="md:hidden">
                            {/* <div >  <SearchComponent style={{ display: flagMobile === 1 ? 'block' : 'none' }} /></div> */}
                            <button
                                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"

                                onClick={() => setNavbar(!navbar)}
                            >
                                {navbar ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6 text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="w-6 h-6 text-white"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <div
                        className={`flex-1 justify-self-center  mt-8 md:block md:pb-0 md:mt-0 ${navbar ? "block" : "hidden"
                            }`}
                    >

                        <>
                            <TreeView
                                className='slide-bg-expand'
                                aria-label="Menu"
                                defaultCollapseIcon={<  AiFillMinusCircle color='rgb(255 255 255 / 64%)' />}
                                defaultExpandIcon={<IoIosAddCircle color='rgb(255 255 255 / 64%)' />}
                                sx={{ flexGrow: 1, overflowY: 'hidden', color: "#000", width: "100vw" }}

                            >
                                {

                                    // Menus.filter(i => ((i.permission.includes(userRole) || (i.permission.includes("ALL")) && userRole !== "VENDER")) ||
                                    //     ((i.permission.includes(userRole)) && userRole === "VENDER")

                                    // ).map((menu, index) => (
                                    Menus?.map((menu, index) => (

                                        <StyledTreeItem nodeId={parseInt("" + menu.orderID + menu.title)}
                                            action={menu.path}
                                            labelText={menu.title}
                                            to={menu.path}
                                            ttitle={menu.title}
                                            className="text-white"
                                            // labelInfo={ArrowDropDownIcon}
                                            onClick={() => setNavbar(menu.path === "" ? navbar : !navbar)}
                                            // labelIcon={menu.src} 
                                            labelIcon={menuIcon(menu.src)}
                                        >

                                            {

                                                menu.sub?.map((sub, subIndex) => (
                                                    //{
                                                    //     return (

                                                    <Link to={sub.path} key={"" + index + subIndex + sub.orderID + sub.title}>
                                                        <StyledTreeItem
                                                            nodeId={parseInt("" + sub.orderID)}
                                                            depth={1}
                                                            labelText={sub.title}
                                                            // labelIcon={sub.src}
                                                            labelIcon={menuIcon(sub.src)}

                                                            to={sub.path}
                                                            ttitle={sub.title}
                                                            onClick={() => setNavbar(!navbar)}
                                                        />
                                                    </Link>
                                                )
                                                    // }
                                                )
                                            }

                                        </StyledTreeItem>

                                    ))
                                }

                            </TreeView></>

                    </div>
                </div>



            </div>
        )

    }

    const handleLogout = () => {

        setUserName("");
        localStorage.clear();
        navigate('../login');
        // <Redirect to='/login' />
    };
    return (


        <nav className="w-full bg-washblue shadow">
            {loadingPageFlag === 1 && <LoadingPage flag={loadingPageFlag} />}
            {isMobile ? <EnhancedTableHeadMB /> : <EnhancedTableHead />}


        </nav>





    )
}

function CustomLink({ to, children, ...props }) {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })

    return (
        <li className={isActive ? "active" : ""}>
            <Link to={to} {...props}>
                {children}
            </Link>
        </li>
    )
}



export default Navbar
